export const PreQualifierLoadingProductStyles = {
  loadingContainer: 'flex flex-col justify-center my-6',
}
